<div class="container-fluid py-5">
  <div class="row">
    <div class="col-md-12">
      <div class="card shadow-sm">
        <div class="card-body p-5">
          <h3 class="pt-0 pb-5">Work Group Access</h3>
          @if (this.users && this.users.length > 0) {
            <div class="row mb-3">
              <div class="col pt-4"><h6 class="p-0">Showing {{showingStart}}-{{showingEnd}} of {{totalItems}}</h6></div>
            </div>
          }
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th rowspan="2">User ID</th>
                  <th rowspan="2">Name</th>
                  <th rowspan="2">Email</th>
                  <th rowspan="2">Phone</th>
                  <th rowspan="2">Scope</th>
                  <th colspan="2" class="text-center">Transaction Access Rights</th>
                </tr>
                <tr>
                  <th>Book of Shipment</th>
                  <th>Bill of Lading</th>
                </tr>
              </thead>
              <tbody>
                <!-- start loop -->
                @for (user of userPage; track user) {
                  <tr>
                    <td><a [routerLink]="[]" (click)="userSelected(user); updateModal.show()">{{user.id}}</a></td>
                    <td>{{user.firstName}} {{user.middleInitial}} {{user.lastName}}</td>
                    <td>{{user.email}}</td>
                    <td>{{user.phone}}</td>
                    <td>{{user.transactionAccessRights.workGroupAdminScope}}</td>
                    <td>{{user.transactionAccessRights.bookShipment}}</td>
                    <td>{{user.transactionAccessRights.billOfLading}}</td>
                  </tr>
                }
                <!-- end loop -->
              </tbody>
            </table>
          </div>
          <div class="alert alert-info">
            Please Select a User Id to Update User's Access
          </div>
          <app-pagination [totalItems]="totalItems" [itemsPerPage]="itemsPerPage"
            (itemsPerPageChange)="itemsPerPageChanged($event)" [currentPage]="currentPage"
          (currentPageChange)="page($event)"></app-pagination>
        </div>
      </div>
    </div>
  </div>
</div>

<div>
  <select>
    @for (scope of scopes; track scope) {
      <option></option>
    }
  </select>
</div>
<!-- Update Permissions -->
<div bsModal #updateModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-sizes-name3">
  <div class="modal-dialog right narrow">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="dialog-sizes-name3" class="modal-title p-0">Update Permissions</h4>
        <div class="close pull-right" aria-label="Close" (click)="updateModal.hide()">
          <span aria-hidden="true">&times;</span>
        </div>
      </div>
      <div class="modal-body">
        <form [formGroup]="permissionsForm">
          <div class="row">
            <div class="col-xs-4">
              <h6 class="ml-2">User ID</h6>
              <p class="ml-2">{{selectedUser?.id}}</p>
            </div>
            <div class="col-xs-4">
              <h6>Name</h6>
              <p>{{selectedUser?.firstName}} {{selectedUser?.middleInitial}} {{selectedUser?.lastName}}</p>
            </div>
          </div>
          @if (selectedUser && isWorkGroupAdmin(selectedUser)) {
            <div class="form-row">
              <div class="form-group col-xs-12">
                <label for="work_group_admin_scope">Scope</label>
                <select formControlName="workGroupAdminScope" id="work_group_admin_scope" class="w-100">
                  @for (scope of scopes; track scope) {
                    <option [ngValue]="scope">{{scope}}</option>
                  }
                </select>
              </div>
            </div>
          }
          <div class="form-row">
            <div class="form-group col-xs-12">
              <label for="book_shipment">Book Shipment</label>
              <select formControlName="bookShipment" id="book_shipment" class="w-100">
                @for (right of rights; track right) {
                  <option [ngValue]="right">{{right}}</option>
                }
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-xs-12">
              <label for="bill_of_lading">Bill of Lading</label>
              <select formControlName="billOfLading" id="bill_of_lading" class="w-100">
                @for (right of rights; track right) {
                  <option [ngValue]="right">{{right}}</option>
                }
              </select>
            </div>
          </div>
          <button type="button" class="btn btn-primary w-auto mt-4" (click)="save(); updateModal.hide()">Save</button>
        </form>
      </div>
    </div>
  </div>
</div>
